import React from "react";

import { RouteComponentProps, Router } from "@reach/router";

import { Grid, Paper } from "@material-ui/core";
import { MainLayout } from "pages/Layouts";
import NotFound from "pages/not-found";

import FormPage from "./pages/form";
import SuccessPage from "./pages/success";


const LinkApp: React.FC<RouteComponentProps> = () => (
  <MainLayout
    path="/link-app"
    showHeader
    showFooter
    backgroundColor="gray"
  >
    <Grid container spacing={2} justifyContent="center">
      <Grid item xs={12} md={6}>
        <Paper>
          <Router primary={false} style={{ padding: "0.5em 3em 2em" }}>
            <FormPage path="/" />
            <FormPage path="/:linkCode" />

            <SuccessPage path="/success" />

            <NotFound default />
          </Router>
        </Paper>
      </Grid>
    </Grid>
  </MainLayout>
);

export default LinkApp;
